<template>
  <div>
    <v-card>
      <v-data-table
        mobile-breakpoint="0"
        item-key="id"
        :options.sync="pagination"
        :items-per-page="5"
        :headers="headers"
        :items="items"
        :server-items-length="count"
        loading-text="Đang Tải"
        :loading="loading"
      >
        <template v-slot:[`item.student`]="{ item }">
          <card-student-name :student="item.student" link />
        </template>
        <template v-slot:[`item.dob`]="{ item }">
          <span v-if="item.student">{{ item.student.dob | ddmmyyyy }}</span>
        </template>
        <template v-slot:[`item.class`]="{ item }">
          <router-link style="text-decoration: none" :to="'/class/' + (item.class && item.class._id)">
            <span v-if="item.class">{{ item.class.title || '' }}</span>
          </router-link>
        </template>
        <template v-slot:[`item.totalAmount`]="{ item }">
          <span class="fee">{{ item.totalAmount.toLocaleString('en-US') }}</span>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-btn icon @click="() => openDetailDebt(item)">
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </template>
      </v-data-table>
      <div>
        <totalDebt />
      </div>
    </v-card>
    <DialogDebt ref="dialog-debt" />
  </div>
</template>

<script>
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { originHeaders } from './helper'
import ActionReport from '@/modules/tuitionFee/detail-period/action/ActionReport.vue'
import DialogDebt from '@/modules/tuitionFee/debt-manager/DialogDebt.vue'
import totalDebt from './totalDebt.vue'
export default {
  components: {
    CardStudentName,
    ActionReport,
    DialogDebt,
    totalDebt,
  },
  data() {
    return {
      pagination: {},
      pageText: '',
    }
  },
  computed: {
    ...mapGetters({
      items: 'studentDebt/getStudentDebts',
      query: 'studentDebt/getQuery',
      count: 'studentDebt/count',
      loading: 'studentDebt/loading',
    }),
    headers() {
      return originHeaders()
    },
    footerTable() {
      let footer = {
        'items-per-page-text': 'Số học sinh mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5,
        'page-text': this.pageText,
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },
  },
  created() {
    this.setStudentDebts([])
  },
  methods: {
    ...mapActions({
      fetchStudentDebt: 'studentDebt/fetchStudentDebt',
    }),
    ...mapMutations({
      setQuery: 'studentDebt/setQuery',
      setStudentDebts: 'studentDebt/setStudentDebts',
      setLoading: 'studentDebt/setLoading',
    }),
    openDetailDebt(item) {
      this.$refs['dialog-debt'].openDialog(item)
    },
  },
  watch: {
    pagination: {
      async handler(newOptions, oldOptions) {
        if (newOptions && oldOptions) {
          try {
            this.setLoading(true)
            const params = {
              ...this.query,
              _limit: newOptions.itemsPerPage,
              _start: (newOptions.page - 1) * newOptions.itemsPerPage,
            }
            await this.fetchStudentDebt(params)
          } catch (e) {
            this.$alert.error(e)
          } finally {
            this.setLoading(false)
          }
        }
      },
      immediate: true,
    },
  },
}
</script>
<style scoped>
.nowrap {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  width: 230px;
}

.tooltip {
  word-wrap: break-word;
}

div.note {
  max-width: 400px;
}

@media screen and (max-width: 1597px) {
  div.note {
    max-width: 300px;
  }
}

@media screen and (max-width: 1497px) {
  div.note {
    max-width: 200px;
  }
}
.fee {
  color: #fd6b6b !important;
  font-weight: 500;
}
</style>
